module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-getting-past-the-addicted-self-large@3x.dfb4143a.png";